export const noticias = [
    {
        titulo: "MeuCupom.com faz brincadeira com De Volta Para o Futuro",
        resumo: "Para comemorar o dia 21 de outubro de 2015 – data em que os personagens Dr. Brown, Marty Mcfly e sua namorada Jennifer chegam ao futuro –, o site de cupons MeuCupom.com decidiu fazer uma brincadeira para os fãs de “De Volta Para o Futuro (Back to the Future)...",
        imagem: "https://static.meucupom.com/uploads/public/562/7ed/dbe/5627eddbec5b0649533275.jpg",
        link: "https://www.megacurioso.com.br/cinema/85490-meucupom-com-faz-brincadeira-com-de-volta-para-o-futuro.htm",
        data: "21/10/2015",
    },
    {
        titulo: "Site MeuCupom traz ofertas tentadoras para os amantes de tec",
        resumo: "A vida não anda fácil para os amantes brasileiros da tecnologia, especialmente agora que a presidente Dilma Rousseff sancionou a medida provisória que aumenta os impostos...",
        imagem: "https://static.meucupom.com/uploads/public/561/fe3/573/561fe35735ddc877849105.png",
        link: "https://www.megacurioso.com.br/cinema/85490-meucupom-com-faz-brincadeira-com-de-volta-para-o-futuro.htm",
        data: "24/06/2015",
    },
    {
        titulo: "Publici|w lança plataforma de cupons de desconto.",
        resumo: "A publici|w lançou em maio deste ano a plataforma de descontos MeuCupom. O grupo, que não informa qual foi o investimento inicial no negócio, diz que tudo foi feito com recursos próprios...",
        imagem: "https://static.meucupom.com/uploads/public/561/fe3/43b/561fe343b0735869498780.png",
        link: "https://revistapegn.globo.com/Banco-de-ideias/E-commerce/noticia/2015/06/publiciw-lanca-plataforma-de-cupons-de-desconto.html",
        data: "16/06/2015",
    },
    {
        titulo: "Recém-lançado, MeuCupom.com já atinge mais de 500 mil acesso",
        resumo: "O MeuCupom.com desde seu lançamento, em 18 de maio teve mais de 500 mil acessos, com mais de 1,5 milhão de pageviews...",
        imagem: "https://static.meucupom.com/uploads/public/561/fe4/2e7/561fe42e7eb1a000830031.png",
        link: "https://ecommercenews.com.br/noticias/balancos/recem-lancado-meucupom-com-ja-atinge-mais-de-500-mil-acessos/#sthash.fVA3S9pb.dpbs",
        data: "03/06/2015",
    },
    {
        titulo: "Lista reúne sites de cupons de desconto.",
        resumo: "Se deslocar por shoppings lotados, comparar preços em diversas lojas, lidar com vendedores inconvenientes e, muitas vezes, voltar para casa de mãos vazias...",
        imagem: "https://static.meucupom.com/uploads/public/561/fe4/8a7/561fe48a77914000486370.png",
        link: "https://www.techtudo.com.br/noticias/2015/05/lista-reune-sites-de-cupons-de-desconto-veja-como-economizar-online.ghtml",
        data: "31/05/2015",
    },
    {
        titulo: "Encontre ofertas de desconto em um portal personalizado com",
        resumo: "MeuCupom é um site que reúne cupons e ofertas para mais de 90 lojas. Embora perda em quantidade de parceria para outros serviços de desconto, a plataforma ganha em ferramentas. ...",
        imagem: "https://static.meucupom.com/uploads/public/561/fe4/8a7/561fe48a77914000486370.png",
        link: "https://www.techtudo.com.br/tudo-sobre/meucupom/",
        data: "20/05/2015",
    },
    {
        titulo: "MeuCupom.com chega ao Brasil.",
        resumo: "O MeuCupom.com acaba de ser lançado no mercado brasileiro. O site trabalha com cupons de descontos exclusivos de 300 varejistas como Walmart, Netshoes...",
        imagem: "https://static.meucupom.com/uploads/public/561/fe3/222/561fe32226fa0684151374.png",
        link: "https://ecommercenews.com.br/noticias/lancamentos/meucupom-com-chega-ao-brasil/#sthash.WGHwDdJa.dpbs",
        data: "18/05/2015",
    },
    ]